var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cards.length > 0)?_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.cards,"items-per-page":10},on:{"click:row":function (item) { return _vm.$router.push({
          name: 'cartes-details',
          params: { id: item.id },
        }); }}}):_c('div',[_vm._v("Pas de cartes pour ce client.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }